export const SYNC_SEARCH_TERM = 'SYNC_SEARCH_TERM';